import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress cross-origin "Script error" from external scripts before React overlay catches them
const origOnerror = window.onerror;
window.onerror = function(message) {
  if (message === "Script error." || message === "Script error") return true;
  if (origOnerror) return origOnerror.apply(this, arguments);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
